import React from "react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { Box, Backdrop, Button, CircularProgress, Container, Typography } from "@mui/material";
import { Context } from "../App";
import Billet from "../components/ui/Billet";
import { useNavigate } from "react-router-dom";

export default function MesBillets(){
    const navigate = useNavigate()
    const { userId, setUserId, isConnected, setIsConnected } = React.useContext(Context)
    const [load, setLoad] = React.useState(true);
    const [billets, setBillets] = React.useState([]);

    React.useEffect(()=>{
        let token = localStorage.getItem('token');
        if (!token) {
            return setIsConnected(false)
        }

        setLoad(true);
        const query = {'owner.id': userId, statut: {$in: ['valide', 'validé']}};
        fetch(process.env.REACT_APP_API_URL.concat('/billets'), {method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            }, body: JSON.stringify(query)
        })
        .then((res) => {
            const token = res.headers.get('x-auth-token');
            if (token) localStorage.setItem('token', token);
            if (res.status === 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                setIsConnected(false);
                throw new Error('Unauthorized');
            }
            return res.json()
        }).then((data) => {
            setBillets(data);
            setLoad(false);
        }).catch((err) => {
            console.error("Error fetching panier:", err);
            setLoad(false);
        });
    }, [userId])

    React.useEffect(() => {}, [billets]);
    
    return(
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Header />

            <Container maxWidth="md" sx={{ my: 4, minWidth:'840px', display:'flex', flexDirection:'column', rowGap: 2 }}>
                <Typography variant="h1" gutterBottom>Mes billets</Typography>

                {billets.length <= 0 && !load ? <Typography variant="subtitle1" sx={{my:2}}>
                    <span style={{fontWeight:'bold', fontSize:18}}>Vous n'avez aucun billet pour l'instant.</span><br/><br/>Vous pouvez vous inscrire à des événements sur les pages d'événement, puis vos billets apparaîtront ici.<br/>
                    <span style={{color:'var(--mui-palette-primary-main)', textAlign:'right', fontWeight:'bold', cursor:'pointer'}} onClick={()=>navigate('/billeterie')}>
                    Poursuivre mes achats</span>
                </Typography>
                :
                billets.map((item, index) => <Billet key={index} billet={item} setLoad={setLoad} />)}
                
            </Container>

            <Backdrop open={load}><CircularProgress/></Backdrop>

            <Footer />
        </Box>
    )
} 